var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4592 3.54036C14.7131 3.7942 14.7131 4.20575 14.4592 4.45959L6.45923 12.4596C6.20539 12.7134 5.79383 12.7134 5.53999 12.4596L1.53999 8.4596C1.28615 8.20575 1.28615 7.7942 1.53999 7.54036C1.79383 7.28652 2.20539 7.28652 2.45923 7.54036L5.99961 11.0807L13.54 3.54036C13.7938 3.28652 14.2054 3.28652 14.4592 3.54036Z",
    fill: "currentColor"
  })));
};
export default SvgCheck;